/**
 * Redux Reducers Index
 *
 * This file aggregates all Redux reducers (state slices) for the application.
 * Each reducer manages a specific domain of the application state.
 *
 * State Structure:
 * {
 *   spinner: { showSpinner: boolean }           - Global loading state
 *   auth: { user, token, permissions, ... }     - Authentication state
 *   products: { data, loading, filters, ... }   - Products page state
 *   jobs: { data, loading, ... }                - Jobs page state
 *   dateMath: { ... }                           - Date math page state
 *   dateMathCalculations: { ... }               - Date math calculations modal
 *   rights: { ... }                             - Rights page state
 *   dealVersion: { ... }                        - Deal version page state
 *   productGate: { ... }                        - Rightsline product gate state
 *   pmxDeliveries: { ... }                      - PMX deliveries page state
 *   templates: { ... }                          - Upload templates state
 *   users: { ... }                              - Users admin page state
 *   dealDROChanges: { ... }                     - Deal DRO changes state
 *   jobMetrics: { ... }                         - Job metrics modal state
 *   jobTasks: { ... }                           - Job tasks modal state
 *   readyProducts: { ... }                      - Ready products page state
 * }
 *
 * Adding a New Reducer:
 * 1. Create reducer file in src/datastage/store/[feature]/reducer.js
 * 2. Import the reducer here
 * 3. Add it to the datastageReducers object
 *
 * @see src/shared/redux/store.js - Store configuration
 */

// UI State
import spinner from './spinner/reducer';

// Authentication
import auth from './auth/reducer';

// Page-specific State
import { dateMath } from './dateMath/reducer';
import { dateMathCalculations } from './dateMathCalculations/reducer';
import { jobs } from './jobs/reducer';
import { jobMetrics } from './jobMetrics/reducer';
import { jobTasks } from './jobTasks/reducer';
import { pmxDeliveries } from './pmxDeliveries/reducer';
import { productGate } from './productGate/reducer';
import { rights } from './rights/reducer';
import { templates } from './templates/reducer';
import { dealVersion } from './dealVersion/reducer';
import { products } from './products/reducer';
import { users } from './users/reducer';
import { dealDROChanges } from './dealDROChanges/reducer';
import {readyProducts} from "datastage/store/readyProducts/reducer.js";

/**
 * Combined Reducers Object
 * Export all reducers to be combined in the store
 */
export const datastageReducers = {
    // UI
    spinner,

    // Auth
    auth,

    // Features
    templates,
    jobs,
    jobMetrics,
    jobTasks,
    dateMath,
    dateMathCalculations,
    productGate,
    dealVersion,
    rights,
    pmxDeliveries,
    products,
    readyProducts,
    users,
    dealDROChanges,
};
